import React, { useState } from "react";

const withToast = (WrappedComponent) => {
  const Toast = (props) => {
    const [toastValue, setToastValue] = useState(null);

    const setToast = ({ title, text, action, timeout = 3000 }) => {
      setToastValue({
        title,
        text,
        action,
      });
      setTimeout(() => setToastValue(null), timeout);
    };

    return (
      <WrappedComponent {...props} toast={{ value: toastValue, setToast }} />
    );
  };

  return Toast;
};

export default withToast;
